import {
  SET_MG_GAME_NAMES,
  SET_MG_GAME_IMAGES,
  SET_MG_GAME_POLA,
  SET_GAME_ISLOADING,
  SET_GAME_ISERROR
} from '../actionTypes';

const initialState = {
  mgNames: [],
  mgImages: [],
  mgPolas: [],
  nameAndImagesIsLoading: true,
  isError: null
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_MG_GAME_NAMES:
      return { ...state, mgNames: action.payload }
    case SET_MG_GAME_IMAGES:
      return { ...state, mgImages: action.payload };
    case SET_MG_GAME_POLA:
      return { ...state, mgPolas: action.payload };
    case SET_GAME_ISLOADING:
      return { ...state, nameAndImagesIsLoading: action.payload };
    case SET_GAME_ISERROR:
      return { ...state, isError: action.payload };
    default:
      return state;
  };
};

export default reducer;